import { Flex, useMantineTheme } from '@mantine/core'
import React from 'react'
import { SectionPlaceholder } from 'src/components'
import { ContactDetails, ContactForm } from './components'
import { useMediaQuery } from '@mantine/hooks'
import { MenuLinks } from 'src/content'

export interface ContactProps {}

export const Contact: React.FC<ContactProps> = () => {
  const theme = useMantineTheme()
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.md})`)
  const { MenuAnchor } = MenuLinks

  return (
    <SectionPlaceholder
      title="Contact"
      customStyles={{ minHeight: 'inherit', paddingBottom: 60 }}
      anchorClassName={MenuAnchor.Contact}
    >
      <Flex
        direction={isMobile ? 'column' : 'row'}
        mt="xl"
        justify={'space-between'}
        align={isMobile ? 'center' : 'flex-start'}
        gap={theme.spacing.xl}
      >
        <ContactDetails />
        <ContactForm />
      </Flex>
    </SectionPlaceholder>
  )
}
